/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacts_Trash_RestoredInputs */



/**
* | output |
* | --- |
* | "App restored. It is private; share it again to create a new link." |
*
* @param {Artifacts_Trash_RestoredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_trash_restored = /** @type {((inputs?: Artifacts_Trash_RestoredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Trash_RestoredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("App wiederhergestellt. Sie ist privat; teile sie erneut, um einen neuen Link zu erzeugen.")
	return /** @type {LocalizedString} */ ("App restored. It is private; share it again to create a new link.")
});